/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainStoreEnumsSupportedWebPublishingPlatformFromJSON, FxIdDomainStoreEnumsSupportedWebPublishingPlatformToJSON, } from './FxIdDomainStoreEnumsSupportedWebPublishingPlatform';
/**
 * Check if a given object implements the FxIdWebFeaturesStoreStoreDataRequest interface.
 */
export function instanceOfFxIdWebFeaturesStoreStoreDataRequest(value) {
    if (!('Game' in value) || value['Game'] === undefined)
        return false;
    if (!('WebPublishingPlatform' in value) || value['WebPublishingPlatform'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesStoreStoreDataRequestFromJSON(json) {
    return FxIdWebFeaturesStoreStoreDataRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreStoreDataRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Game': json['Game'],
        'ProductsSku': json['ProductsSku'] == null ? undefined : json['ProductsSku'],
        'Locale': json['Locale'] == null ? undefined : json['Locale'],
        'WebPublishingPlatform': FxIdDomainStoreEnumsSupportedWebPublishingPlatformFromJSON(json['WebPublishingPlatform']),
        'Currency': json['Currency'] == null ? undefined : json['Currency'],
        'Country': json['Country'] == null ? undefined : json['Country'],
        'StoreAdditionalData': json['StoreAdditionalData'] == null ? undefined : json['StoreAdditionalData'],
    };
}
export function FxIdWebFeaturesStoreStoreDataRequestToJSON(json) {
    return FxIdWebFeaturesStoreStoreDataRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreStoreDataRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Game': value['Game'],
        'ProductsSku': value['ProductsSku'],
        'Locale': value['Locale'],
        'WebPublishingPlatform': FxIdDomainStoreEnumsSupportedWebPublishingPlatformToJSON(value['WebPublishingPlatform']),
        'Currency': value['Currency'],
        'Country': value['Country'],
        'StoreAdditionalData': value['StoreAdditionalData'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesStoreStoreDataRequest.js.map